import request from './request';

const closeDates = {
  getAll: () => request.get(`dashboard/admin/shop-closed-dates`),
  getById: (id) => request.get(`dashboard/admin/shop-closed-dates/${id}`),
  create: (data) => request.post(`dashboard/admin/shop-closed-dates`, data, {}),
  update: (id, data) =>
    request.put(`dashboard/admin/shop-closed-dates/${id}`, data, {}),
  deleteById: (id) => request.delete(`dashboard/admin/shop-closed-dates/${id}`),
  delete: (params) =>
    request.delete(`dashboard/admin/shop-closed-dates/delete`, { params }),
};

export default closeDates;
